import { getApi } from "./api_instance";

export const getTransactionDetails = async (transactionId, dispatch) => {
  try {
    return getApi({
      apiUrl: `/payments/api/transactions/detail?transaction_id=${transactionId}`,
      dispatch,
      sendToken: true,
    });
  } catch (error) {
    throw error;
  }
};
